module.exports = __webpack_public_path__ + "img/540.e6d44387.jpg";